


























































import { LOGIN } from "@/queries/anonymous/mutation.graphql";

import Vue from "vue";
export default Vue.extend({
  data: () => ({
    form: {
      email: "",
      password: ""
    },
    isLoading: false
  }),
  methods: {
    login() {
      this.isLoading = true;
      this.$store.commit("loadersModule/toggleGlobalLoader", true);
      this.$apollo
        .mutate({
          mutation: LOGIN,
          variables: {
            ...this.form
          }
        })
        .then((data: any) => {
          this.isLoading = false;
          this.$store.commit("loadersModule/toggleGlobalLoader", false);
          if (data.data.login) {
            const userToken = data.data.login.tokenKey;
            const userId = data.data.login.userId;
            this.$store.commit("authModule/authenticate", {
              userToken,
              userId
            });
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.$store.commit("loadersModule/toggleGlobalLoader", false);
          this.$toastr.e(error.graphQLErrors[0].message);
        });
    }
  }
});
